// extracted by mini-css-extract-plugin
module.exports = {"title":"Reports_title__2fOpi"};